export default __webpack_public_path__ + "static/media/material-handling-icon.94a74a25.svg";